import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/expectModel',
  component: LAYOUT,
  name: 'ExpectModel',
  redirect: '/expectModel/index',
  meta: {
    title: '意向车型',
  },
  children: [
    {
      path: 'index',
      name: 'expectModelIndex',
      meta: {
        title: '车型列表',
      },
      component: () => import('@/views/expectModel/index'),
    },
    {
      path: 'form',
      name: 'expectModelForm',
      meta: {
        title: '我的意向车型',
      },
      component: () => import('@/views/expectModel/form'),
    },
  ],
};
